import { useCallback } from 'react';

import { useMarkExplainerVideoSeen, useUserConfig } from '@/features/_shared/user';
import { FeatureFlag } from '@/services/feature-flags';
import { useFlag } from '@/services/feature-flags/react';
import { StorageKeys } from '@/services/storage';
import { useStorageValue } from '@/services/storage/react';
import { useAppSelector } from '@/store/hooks';

export const useExplainerVideoModal = () => {
  const markSeenMutation = useMarkExplainerVideoSeen();
  const isFeatureEnabled = useFlag(FeatureFlag.ExportVideoExplainer);
  const tripTokenStatus = useAppSelector(state => state.tripToken.status);
  const { data: userConfigData, isSuccess: isConfigLoaded } = useUserConfig();
  const exportVideoExplainerSeen = userConfigData?.exportVideoExplainerSeen;
  const impersonatorEmail = useStorageValue(StorageKeys.Impersonator);

  const isOpen =
    isFeatureEnabled &&
    tripTokenStatus === 'fulfilled' &&
    isConfigLoaded &&
    !impersonatorEmail &&
    !exportVideoExplainerSeen;

  const onDismiss = useCallback(() => {
    markSeenMutation.mutate();
  }, [markSeenMutation]);

  return { isOpen, onDismiss };
};
